import { createModel } from "@rematch/core";
import { IDLE, FETCHING } from "./constants";
import { fetchFrom } from '../utils/fetchData'

interface StateT {
  status: StatusT,
  swishToken: string | null,
  paymentStatus: null | string,
  paymentUrl: string | null,
  currentOrderId: string | null,
  currentOrder: any,
  receipt: any
}

export type StatusT = "IDLE" | "FETCHING" | "ERROR"

export const initialOrderState: StateT = {
  status: IDLE,
  swishToken: null,
  paymentStatus: null,
  paymentUrl: null,
  currentOrderId: null,
  currentOrder: {},
  receipt: undefined
}

export const order = createModel()({
  state: initialOrderState,
  reducers: {
    startFetching (state, payload) {
      return { ...state, status: FETCHING };
    },
    stopFetching (state) {
      return { ...state, status: IDLE };
    },
    setError (state) {
      return { ...state, status: 'ERROR' };
    },
    setSwishToken (state, payload: string) {
      return { ...state, swishToken: payload };
    },
    setPaymentUrl (state, payload: string) {
      return { ...state, paymentUrl: payload };
    },
    setPaymentStatus (state, payload: string) {
      return { ...state, paymentStatus: payload };
    },
    setCurrentOrderId (state, payload: string) {
      return { ...state, currentOrderId: payload };
    },
    setCurrentOrder (state, payload: any) {
      return { ...state, currentOrder: payload };
    },
    setReceipt (state, payload: any) {
      return { ...state, receipt: payload };
    }
  },
  effects: (dispatch) => ({
    async createOrder (payload, state: any) {

      const { cartId }: { cartId: string | null } = state.cart

      try {
        dispatch.order.startFetching()
        const purchaseEndpoint = '/svc-checkout/v1/purchase'

        if (cartId) {
          const response = await fetchFrom(purchaseEndpoint, {
            method: 'POST',
            body: {
              cartId,
              ssn: state.customer.personalNumber,
            }
          })
          if (response?.message === "TotalPrice must be at least 100 => 1kr") {
            return dispatch.order.createOrder()
          }
          const { orderId, operations } = response
          if (operations && Array.isArray(operations)) {
            const [paymentOption] = operations
            if (paymentOption) {
              const paymentUrl = paymentOption.href
              if (paymentUrl) {
                dispatch.order.setPaymentUrl(paymentUrl)
                dispatch.order.setCurrentOrderId(orderId)
                localStorage.setItem('payexref', paymentUrl)
              }
            } else if (paymentOption) {
              const queryString = paymentOption.href.split('?')
              if (queryString && queryString.length > 0) {
                const queries = queryString[1].split('&')
                const [token] = queries.filter((item: string) => item.includes('token=')).map((tokenQuery: string) => {
                  return tokenQuery.split('=')[1]
                })
                if (token) {
                  dispatch.order.setSwishToken(token)
                  dispatch.order.setCurrentOrderId(orderId)
                }
              }
            }
          }
        }
        dispatch.order.stopFetching()
      } catch (error) {
        console.log(error)
        dispatch.order.setError()
      }
    },
    async getPaymentStatus (payload, state) {
      const { storeId } = payload
      const { currentOrderId }: { currentOrderId: string | null } = state.order
      const orderId = currentOrderId
      try {
        const order = await fetchFrom(`/order/${orderId}/${storeId}`, {
          method: 'GET',
        })
        if (order) {
          dispatch.order.setCurrentOrder(order)
          const { paymentStatus } = order.paymentInformation || {}
          if (paymentStatus) {
            dispatch.order.setPaymentStatus(paymentStatus)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async verifyPaymentStatus (payload, state) {
      const { storeId, orderId } = payload || {}
      try {
        const result = await fetchFrom(`/svc-order/v1/order/${orderId}/store/${storeId}`, {
          method: 'GET',
        })
        const status = result?.paymentInformation?.paymentStatus

        if (status) {
          dispatch.order.setPaymentStatus(status)
        } else {
          dispatch.order.setPaymentStatus('FAILED')
        }
      } catch (error) {
        console.log(error)
        dispatch.order.setPaymentStatus('FAILED')
      }

    },
    // async verifyPayment (payload, state) {
    //   const { storeId, orderId } = payload || {}
    //   try {
    //     const verified = await fetchFrom(`/svc-checkout/v1/verifypayment/store/${storeId}/order/${orderId}`, {
    //       method: 'GET',
    //     })
    //     if (verified?.status) {
    //       dispatch.order.setPaymentStatus(verified?.status)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    async getReceipt (storeId, state, orderId) {
      if (orderId) {
        try {
          const receipt = await fetchFrom(`/order/${orderId}/${storeId}/receipt`, {
            method: 'GET',
          })
          dispatch.order.setReceipt(receipt)
        } catch (error) {
          console.log(error)
        }
      }
    }
  }),
});
